// extracted by mini-css-extract-plugin
export default {"triage":"Triage_triage__MHGS9","container":"Triage_container__Np69+"};